import { Observer, PartialObserver } from "rxjs";

export namespace NGUtils {

  /**
   * Return an api error handled observer object.
   *
   * @export
   * @template T
   * @param {PartialObserver<T>} observerObj
   * @return {*}  {Observer<T>}
   */
  export function genApiObserverObj<T>(observerObj: PartialObserver<T>): Observer<T> {
    return {
      next: (result: T) => {
        if (observerObj.next) {
          observerObj.next(result);
        }
      },
      error: err => {
        if (observerObj.error) {
          observerObj.error(err);
        } else {
          if (!err.isHandle) {
            throw err;
          }
        }
      },
      complete: () => {
        if (observerObj.complete) {
          observerObj.complete();
        }
      }
    };
  }
}
